export const defaultBitLockerValues = {
  ComputerDns: "",
  ComputerName: "",
  FullDate: "",
  PasswordID: "",
  RecoveryGuid: "",
  ShortDate: "",
};

export const bitLockerFormFields = {
  computerDns: { id: "ComputerDns", label: "Computer" },
  computerName: { id: "ComputerName", label: "" },
  fullDate: { id: "FullDate", label: "Date" },
  passwordID: { id: "PasswordID", label: "Password ID" },
  recoveryGuid: { id: "RecoveryGuid", label: "Recovery Password" },
  shortDate: { id: "ShortDate", label: "" },
};
